import React from 'react'
import Modal from '../Modal'
import Loader from '../Loader'

interface IProps {
  isLoading: boolean
  text?: string
  style?: React.CSSProperties
  modalStyle?: React.CSSProperties
  fontWeight?: number
  margin?: string
  fontSize?: string
}

const ModalLoader = ({ isLoading, text, style, modalStyle, fontWeight, margin, fontSize }: IProps) => {
  return (
    <Modal onlyContent show={isLoading} style={modalStyle} setShow={() => {}}>
      <Loader margin={margin} fontSize={fontSize} fontWeight={fontWeight} style={style} text={text} />
    </Modal>
  )
}

export default ModalLoader
